



















































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import PointerMenu from "../general/PointerMenu.vue";
import Loading from "../general/Loading.vue";

import RentalItemJson from "../../shared/RentalItemJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";
import RentalBookingJson from "../../shared/RentalBookingJson";

export default Vue.extend({
  name: "RentalProductSelect",
  components: {
    OverlayWindow,
    PointerMenu,
    Loading,
    TableView,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    selectedProducts: Array as PropType<RentalBookingJson[]>,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      supportsDatePicker: false,
      detailsTitle: "Produkt auswählen",
      UserPermissionRank: UserPermissionRank,
      allProducts: null as RentalItemJson[] | null,
      searchString: "",
      hasChanges: false,
      loadingGeneral: false as boolean,
    };
  },
  created() {
    this.initView();
  },
  mounted() {
    this.checkDatePickerSupport();
  },
  methods: {
    initView() {
      this.loadAllProducts();
    },

    setCachedData() {
      this.$nextTick(() => {
        this.hasChanges = false;
      });
    },

    checkDatePickerSupport() {
      let testvalue = "a";
      var ele = <HTMLInputElement>this.$refs["testDatePicker"];

      if (ele != null) {
        ele.value = testvalue;

        if (ele.value !== testvalue) {
          this.supportsDatePicker = true;
        }
      }
    },

    async loadAllProducts() {
      if (this.restClient != null) {
        try {
          this.allProducts = await this.restClient.getRentalItems();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    //START set cached data

    //END set cached data

    selectProduct(item: RentalItemJson) {
      this.$emit("change", item);
      this.closeDetails();
    },

    closeDetails() {
      this.$emit("closeOverlay");
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "selectProduct") {
        this.selectProduct(item);
      }
    },

    tableViewItemClicked(item: any) {
      this.selectProduct(item);
    },
  },

  watch: {},

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    productColumns: function (): TableViewColumnDefinitions<RentalItemJson>[] {
      let vue = this;

      return [
        {
          th: "Bezeichnung",
          td: (i) => i.name,
        },
        {
          th: "Kategorie",
          td: (i) => i.category,
        },
        {
          th: "Stückzahl",
          td: (i) => i.amount,
        },
        {
          th: "",
          td: (i) => "Auswählen",
          style: (i) => "text-align:right",
          button: "selectProduct",
        },
      ] as TableViewColumnDefinitions<RentalItemJson>[];
    },

    filteredAllProducts(): RentalItemJson[] | undefined {
      if (this.allProducts != null) {
        var products: RentalItemJson[] = this.allProducts as RentalItemJson[];

        //selected
        let selectedProductIds = this.selectedProducts.map((i: RentalBookingJson) => i.rentalItem?.ID);
        products = products.filter((i) => !selectedProductIds.includes(i.ID));

        //search
        var tokens = this.searchString
          .split(" ")
          .map((t) => t.trim().toLowerCase())
          .filter((t) => t.length > 0);

        for (var token of tokens) {
          products = products.filter(
            (i) => i.name.toLowerCase().includes(token) || i.category.toLowerCase().includes(token)
          );
        }

        return products;
      }
    },
  },
});
